window.atcCard = function (btn) {
  if (!btn || btn.disabled) return;
  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.classList.add('atc-added');

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) throw r;
      return r.json();
    })
    .then(function () {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'product-card' } }
        })
      );
    })
    .catch(function () {})
    .finally(function () {
      setTimeout(function () {
        btn.classList.remove('atc-added');
        btn.disabled = false;
      }, 2000);
    });
};
